import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

export const userCanCreateAlerts = () => {
  const userPermissions = userDetailsStore.getState().permissions

  return Object.keys(userPermissions).some((p) => p.match(/^CREATE_.*_ALERT$/))
}
